import React from 'react';
import { useDispatch } from 'react-redux';
import { DiscountBanner as BannerWithDiscount } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';

import { ProductCode } from '@dev/ee-api/ee-api-models';
import { usePaymentError } from '@/services/hooks/usePaymentError';
import { ShowDialog } from '@/store/dialog/actions';
import { BillingPaths, pathsParams } from '@/services/dictionaries/Paths';

import { useMobile } from '../../hooks/useMobile';
import { useDiscount } from '../../hooks/useDiscount';

// import { ProductCode } from '@dev/ee-api/ee-api-models';
// import { LoginWithDisposableToken } from '@/store/account/actions';

export const DiscountBanner = (): JSX.Element => {
    const isMobile = useMobile();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { anyPaymentError } = usePaymentError();
    const { discountEnabled, bannerProps } = useDiscount();

    if (!discountEnabled || !bannerProps.discount) {
        return null;
    }

    const handleBuyButtonClick = () => {
        if (anyPaymentError) {
            //TODO: renew!
            dispatch(
                ShowDialog({
                    title: t('upgradenotavailable'),
                    body: t('upgradenotavailable_desc_discover_products'),
                    confirmLabel: t('renew'),
                    onClickConfirm: () => {
                        location.href = `${location.origin}${BillingPaths.Billing}`;
                    },
                    cancelLabel: t('cancel'),
                })
            );

            return;
        }

        // dispatch(LoginWithDisposableToken({ productCode: ProductCode.Marketing, isBilling: true }));

        window.location.href = `${location.origin}${BillingPaths.BillingPlanList.replace(
            pathsParams.productCode,
            ProductCode.Marketing.toLowerCase()
        )}`;
    };

    return (
        <BannerWithDiscount
            expireDay={bannerProps.expireDay}
            discount={bannerProps.discount}
            discountDuration={bannerProps.discountDuration}
            isMobile={isMobile}
            buttonOnClick={bannerProps.buyButtonVisible && handleBuyButtonClick}
            translation={
                {
                    discountBanner_desc: bannerProps.customText,
                } as any
            }
        />
    );
};
